
import { impersonate as cognitoImpersonate } from './cognito';

export function impersonate(userToImpersonate) {
    return cognitoImpersonate(userToImpersonate)
        .then(user => {
            if (user) {
                window.location = `/spark/kiosk/users/impersonate/${userToImpersonate.id}`;
            }
        })
        .catch(error => {
            console.log(error);
        });
}
